/* Bistro St.Tropez product-page enhancements. */
(function () {
  'use strict';

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      (window.theme && window.theme.currencyCode) ||
      'AUD';
    var locale = document.documentElement.lang || 'en';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function visibleSlides(slider) {
    return Array.prototype.filter.call(slider.querySelectorAll('[data-media-slide]'), function (slide) {
      return !slide.classList.contains('hide');
    });
  }

  function updateMediaCounter(counter) {
    var wrapper = counter.closest('.product__media__wrapper');
    var slider = wrapper && wrapper.querySelector('[data-product-slideshow]');
    if (!slider) return;

    var slides = visibleSlides(slider);
    var selected = slider.querySelector('[data-media-slide].is-selected:not(.hide)') || slides[0];
    var index = Math.max(0, slides.indexOf(selected));
    var current = counter.querySelector('[data-bst-media-current]');
    var total = counter.querySelector('[data-bst-media-total]');

    if (current) current.textContent = String(index + 1);
    if (total) total.textContent = String(slides.length);
    counter.hidden = slides.length <= 1;
  }

  function initMediaCounter(counter) {
    if (!counter || counter.dataset.bstReady === 'true') return;

    var wrapper = counter.closest('.product__media__wrapper');
    var slider = wrapper && wrapper.querySelector('[data-product-slideshow]');
    if (!slider) return;

    counter.dataset.bstReady = 'true';
    var frame = null;
    var scheduleUpdate = function () {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () {
        updateMediaCounter(counter);
      });
    };

    var observer = new MutationObserver(scheduleUpdate);
    observer.observe(slider, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    slider.addEventListener('theme:image:change', scheduleUpdate);
    scheduleUpdate();
  }

  function bundleVariants(bundle) {
    if (bundle._bstVariants) return bundle._bstVariants;
    var data = bundle.querySelector('[data-bst-bundle-variants]');

    try {
      bundle._bstVariants = JSON.parse(data ? data.textContent : '[]');
    } catch (error) {
      bundle._bstVariants = [];
    }

    return bundle._bstVariants;
  }

  function selectedBundleVariant(bundle) {
    var selects = Array.prototype.slice.call(bundle.querySelectorAll('[data-bst-bundle-option]'));
    selects.sort(function (a, b) {
      return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition);
    });

    var options = selects.map(function (select) { return select.value; });
    if (options.some(function (value) { return !value; })) return null;

    return bundleVariants(bundle).find(function (variant) {
      return variant.options.length === options.length && variant.options.every(function (value, index) {
        return value === options[index];
      });
    }) || null;
  }

  function mainProductState(bundle) {
    var section = bundle.closest('.bst-product-section');
    var idInput = section && section.querySelector('[data-product-form] input[name="id"]');
    var addButton = section && section.querySelector('[data-add-to-cart]');

    return {
      id: idInput ? Number(idInput.value) : Number(bundle.dataset.mainVariantId),
      price: Number(bundle.dataset.mainPrice || 0),
      available: Boolean(idInput && addButton && !addButton.disabled)
    };
  }

  function showBundleError(bundle, message) {
    var error = bundle.querySelector('[data-bst-bundle-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function updateBundle(bundle) {
    if (!bundle) return;

    var toggle = bundle.querySelector('[data-bst-bundle-toggle]');
    var selectors = bundle.querySelector('[data-bst-bundle-selectors]');
    var button = bundle.querySelector('[data-bst-bundle-add]');
    var productPrice = bundle.querySelector('[data-bst-bundle-product-price]');
    var productCompare = bundle.querySelector('[data-bst-bundle-product-compare]');
    var total = bundle.querySelector('[data-bst-bundle-total]');
    var image = bundle.querySelector('.bst-product-bundle__image img');
    var variant = selectedBundleVariant(bundle);
    var main = mainProductState(bundle);
    var isOpen = Boolean(toggle && toggle.checked);

    if (selectors) selectors.hidden = !isOpen;

    if (variant) {
      if (productPrice) productPrice.textContent = formatMoney(variant.price);
      if (productCompare) {
        productCompare.textContent = formatMoney(variant.compare_at_price);
        productCompare.hidden = !(variant.compare_at_price > variant.price);
      }
      if (image && variant.image) image.src = variant.image;
    }

    var shirtPrice = variant ? Number(variant.price) : 0;
    if (total) total.textContent = formatMoney(main.price + shirtPrice);
    if (button) button.disabled = !isOpen || !variant || !variant.available || !main.available;

    if (variant && !variant.available) {
      showBundleError(bundle, 'That shirt combination is currently unavailable. Please choose another option.');
    } else {
      showBundleError(bundle, '');
    }
  }

  function initBundle(bundle) {
    if (!bundle || bundle.dataset.bstReady === 'true') return;
    bundle.dataset.bstReady = 'true';
    updateBundle(bundle);
  }

  async function addBundle(bundle) {
    var button = bundle.querySelector('[data-bst-bundle-add]');
    var label = bundle.querySelector('[data-bst-bundle-button-label]');
    var shirtVariant = selectedBundleVariant(bundle);
    var main = mainProductState(bundle);

    if (!button || button.disabled || !shirtVariant || !main.available) return;

    var originalLabel = label ? label.textContent : 'Add the set to bag';
    var setId = 'holiday-set-' + Date.now();
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding the set…';
    showBundleError(bundle, '');

    try {
      var response = await window.fetch(window.theme.routes.cart + '/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [
            {
              id: main.id,
              quantity: 1,
              properties: { '_BST set': setId }
            },
            {
              id: Number(shirtVariant.id),
              quantity: 1,
              properties: { '_BST set': setId }
            }
          ]
        })
      });

      if (!response.ok) {
        var errorBody = await response.json().catch(function () { return {}; });
        throw new Error(errorBody.description || errorBody.message || 'The set could not be added.');
      }

      var cartResponse = await window.fetch(window.theme.routes.cart + '.js');
      if (!cartResponse.ok) throw new Error('The cart could not be refreshed.');
      var cart = await cartResponse.json();

      document.dispatchEvent(new CustomEvent('theme:cart:change', {
        detail: { cart: cart },
        bubbles: true
      }));
      document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));

      var drawer = document.querySelector('[data-drawer="drawer-cart"]');
      if (drawer) {
        drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
      }

      if (label) label.textContent = 'Set added';
      window.setTimeout(function () {
        if (label) label.textContent = originalLabel;
        button.removeAttribute('aria-busy');
        updateBundle(bundle);
      }, 2200);
    } catch (error) {
      showBundleError(bundle, error.message || 'The set could not be added. Please try again.');
      if (label) label.textContent = originalLabel;
      button.removeAttribute('aria-busy');
      updateBundle(bundle);
    }
  }

  function updateMobileBar(section, variant) {
    if (!section) return;
    var bar = section.querySelector('[data-bst-mobile-bar]');
    if (!bar) return;

    var variantLabel = bar.querySelector('[data-bst-mobile-variant]');
    var priceLabel = bar.querySelector('[data-bst-mobile-price]');
    var submit = bar.querySelector('[data-bst-mobile-submit]');

    if (variant) {
      if (variantLabel) variantLabel.textContent = variant.title || '';
      if (priceLabel) priceLabel.textContent = formatMoney(variant.price);
      if (submit) submit.disabled = !variant.available;
    } else {
      var addButton = section.querySelector('[data-add-to-cart]');
      if (submit && addButton) submit.disabled = addButton.disabled;
    }
  }

  function initMobileBar(bar) {
    if (!bar) return;
    var section = bar.closest('.bst-product-section');
    var mainButton = section && section.querySelector('[data-add-to-cart]');
    if (!mainButton) return;

    if (bar._bstObservedButton === mainButton) return;
    if (bar._bstObserver) bar._bstObserver.disconnect();

    bar._bstObservedButton = mainButton;
    bar._bstObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var hasPassedButton = entry.boundingClientRect.bottom < 0;
        bar.hidden = !hasPassedButton;
      });
    }, { threshold: 0.01 });

    bar._bstObserver.observe(mainButton);
    updateMobileBar(section);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-bst-media-counter]').forEach(initMediaCounter);
    scope.querySelectorAll('[data-bst-bundle]').forEach(initBundle);
    scope.querySelectorAll('[data-bst-mobile-bar]').forEach(initMobileBar);
  }

  function updateFromVariantEvent(event) {
    var section = event.target && event.target.closest && event.target.closest('.bst-product-section');
    if (!section) section = document.querySelector('.bst-product-section');
    var variant = event.detail && event.detail.variant;

    updateMobileBar(section, variant);
    section.querySelectorAll('[data-bst-bundle]').forEach(function (bundle) {
      if (variant) {
        bundle.dataset.mainVariantId = variant.id;
        bundle.dataset.mainPrice = variant.price;
      }
      updateBundle(bundle);
    });

    window.setTimeout(function () { scan(section); }, 80);
  }

  if (!window.BSTProductPageInitialized) {
    window.BSTProductPageInitialized = true;

    document.addEventListener('change', function (event) {
      var bundle = event.target.closest && event.target.closest('[data-bst-bundle]');
      if (!bundle) return;
      if (event.target.matches('[data-bst-bundle-toggle], [data-bst-bundle-option]')) {
        updateBundle(bundle);
      }
    });

    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-bst-bundle-add]');
      if (!button) return;
      event.preventDefault();
      addBundle(button.closest('[data-bst-bundle]'));
    });

    document.addEventListener('theme:variant:change', updateFromVariantEvent);
    document.addEventListener('shopify:section:load', function (event) { scan(event.target); });

    var pageObserver = new MutationObserver(function (mutations) {
      var shouldScan = mutations.some(function (mutation) { return mutation.addedNodes.length > 0; });
      if (shouldScan) window.requestAnimationFrame(function () { scan(document); });
    });

    if (document.body) {
      pageObserver.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        pageObserver.observe(document.body, { childList: true, subtree: true });
      }, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  } else {
    scan(document);
  }
})();
